(() => {
  const AUTO_CLOSE_MS = 4200;
  let closeTimer = null;

  const getParts = () => {
    const host = document.querySelector('cart-notification');
    const notification =
      document.getElementById('cart-notification') ||
      (host ? host.querySelector('.cart-notification') : null);

    return { host, notification };
  };

  const setOverlay = (isActive) => {
    document.documentElement.classList.toggle('figi-cart-notification-active', Boolean(isActive));
  };

  const closeNotification = () => {
    const { host, notification } = getParts();

    window.clearTimeout(closeTimer);
    closeTimer = null;

    if (host && typeof host.close === 'function') {
      host.close();
    } else if (notification) {
      notification.classList.remove('active');
    }

    setOverlay(false);
  };

  const scheduleClose = () => {
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(closeNotification, AUTO_CLOSE_MS);
  };

  const initFigiCartNotification = () => {
    const { notification } = getParts();

    if (!notification) return;

    const syncState = () => {
      const isActive = notification.classList.contains('active');

      setOverlay(isActive);
      window.clearTimeout(closeTimer);

      if (isActive) {
        scheduleClose();
      }
    };

    const observer = new MutationObserver(syncState);

    observer.observe(notification, {
      attributes: true,
      attributeFilter: ['class']
    });

    notification.addEventListener('mouseenter', () => {
      window.clearTimeout(closeTimer);
    });

    notification.addEventListener('mouseleave', () => {
      if (notification.classList.contains('active')) {
        scheduleClose();
      }
    });

    notification.querySelectorAll('.cart-notification__close').forEach((button) => {
      button.addEventListener('click', closeNotification);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && notification.classList.contains('active')) {
        closeNotification();
      }
    });

    syncState();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFigiCartNotification);
  } else {
    initFigiCartNotification();
  }
})();